import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
import { galleryItems } from '../../data/gallery';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-270" data-mp="1402m96gweq7c">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-271" data-mp="1000txnx1z94q">
        <SectionTag icon="🎁" data-id="element-272" data-mp="1e01q4q2dhsdv">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-273" data-mp="191i4kqroyim1">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-274" data-mp="1nsh8vplhukzt">
          Sesiones listas para que preparar tu próxima clase te lleve menos tiempo.
        </p>
        <p className="mt-2 text-sm font-bold text-flash" data-id="element-275" data-mp="1wruiqjdj5bl2">
          11 tomos · 330 sesiones base + 330 variantes · 4 bonos · PDF imprimible
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-276" data-mp="2uz3r131439tb">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-slate-200 bg-bg-primary p-6 shadow-card sm:p-7" data-id="element-277" data-mp="2zygdhmo2mevd" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-278" data-mp="3iw9e2ib82cpl">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-flash/10" data-id="element-279" data-mp="3iu6gnd7qphau">
                <pillar.icon size={22} className="text-flash" data-id="element-280" data-mp="3smchzdjvtb2p" />
              </div>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-muted" data-id="element-281" data-mp="3sofac48ibgal">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-282" data-mp="5ifsdgg7o7sm">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-283" data-mp="1xj642kuy84fl">
              <span className="text-muted line-through" data-id="element-284" data-mp="1xl0ntvuhhqi3">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-285" data-mp="2bbdu7trq8x5b">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-286" data-mp="26j2mw5unq92q">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-287" data-mp="2l7pbyza36f75">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/90" data-id="element-288" data-mp="2gagqaopqbt15">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-289" data-mp="2u8f2pokhpfe0" />
                  <span data-id="element-290" data-mp="2q7lfkxevg4m6">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>

      <div className="mx-auto mt-12 max-w-6xl px-4 sm:px-6" data-id="element-291" data-mp="zvxn935w7jjx">
        <div className="text-center" data-id="element-292" data-mp="vuc26uj7fyyn">
          <h3 className="font-heading text-2xl font-extrabold uppercase leading-tight text-ink sm:text-3xl" data-id="element-293" data-mp="vverwz4sjvcz">
            Así son las fichas que llevarás a clase.
          </h3>
          <p className="mt-2 text-sm text-muted sm:text-base" data-id="element-294" data-mp="pqfjv5u7nnhi">Estas son páginas reales de los PDF incluidos.</p>
        </div>

        <div className="scrollbar-hide mt-6 flex gap-4 overflow-x-auto pb-2" data-id="element-295" data-mp="bzkgua6e80lu">
          {galleryItems.map(item => <figure key={item.title} className="w-56 flex-shrink-0 sm:w-64" data-id="element-296" data-mp="gwu5hnlyk88m">
              <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-card" data-id="element-297" data-mp="20cyf8ksxfrv">
                <img src={item.image} alt={`${item.tag} — ${item.text}`} width={450} height={637} loading="lazy" decoding="async" className="aspect-[450/637] w-full object-cover" data-id="element-298" data-mp="72kcc3p6z5wu" />
              </div>
              <figcaption className="mt-3" data-id="element-299" data-mp="1se29w8wltocs">
                <span className="inline-block rounded-full bg-flash/10 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide text-flash" data-id="element-300" data-mp="1sd10e8v8l9x6">
                  {item.tag}
                </span>
                <p className="mt-1.5 font-heading text-sm font-bold text-ink" data-id="element-301" data-mp="3jjp1cnnoczqy">{item.title}</p>
                <p className="mt-1 text-xs leading-relaxed text-muted" data-id="element-302" data-mp="3ei9c0jegs72r">{item.text}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}